import React from 'react'

type MasterAuditHubChoice = 'master' | 'remitano' | 'country'

interface MasterAuditModeChooserProps {
  open: boolean
  onClose: () => void
  onSelect: (choice: MasterAuditHubChoice) => void
}

export function MasterAuditModeChooser({ open, onClose, onSelect }: MasterAuditModeChooserProps) {
  if (!open) return null

  const btnStyle: React.CSSProperties = {
    width: '100%',
    textAlign: 'left',
    padding: '14px 16px',
    borderRadius: 8,
    border: '1px solid #333',
    background: '#111',
    color: '#fff',
    cursor: 'pointer',
    marginBottom: 10,
  }

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Master Audit tools"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 10050,
        background: 'rgba(0,0,0,0.65)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
      }}
      onClick={onClose}
    >
      <div
        style={{
          width: '100%',
          maxWidth: 420,
          background: '#0a0a0a',
          border: '1px solid #333',
          borderRadius: 12,
          padding: 20,
          boxShadow: '0 12px 40px rgba(0,0,0,0.45)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <h3 style={{ margin: 0, fontSize: 18, color: '#fff' }}>Master Audit</h3>
          <button
            type="button"
            onClick={onClose}
            style={{ background: 'transparent', border: 'none', color: '#aaa', cursor: 'pointer', fontSize: 18 }}
            aria-label="Close"
          >
            ×
          </button>
        </div>
        <p style={{ color: '#9ca3af', fontSize: 13, marginTop: 0, marginBottom: 16, lineHeight: 1.5 }}>
          Choose which audit tool to open.
        </p>

        <button type="button" style={btnStyle} onClick={() => onSelect('master')}>
          <div style={{ fontWeight: 700, marginBottom: 4 }}>Master Audit</div>
          <div style={{ fontSize: 12, color: '#9ca3af' }}>Existing platform financial rollup per user</div>
        </button>

        <button type="button" style={btnStyle} onClick={() => onSelect('remitano')}>
          <div style={{ fontWeight: 700, marginBottom: 4 }}>Database audit</div>
          <div style={{ fontSize: 12, color: '#9ca3af' }}>
            Remitano deposits vs Aureus capture by date/hash (mismatches highlighted)
          </div>
        </button>

        <button type="button" style={{ ...btnStyle, marginBottom: 0 }} onClick={() => onSelect('country')}>
          <div style={{ fontWeight: 700, marginBottom: 4 }}>Country audits</div>
          <div style={{ fontSize: 12, color: '#9ca3af' }}>
            Shares purchased grouped by country, users, and phase
          </div>
        </button>
      </div>
    </div>
  )
}

export type { MasterAuditHubChoice }
